<template>
  <div style="height:210px;" class="trend_table">
    <el-table
      :data="trendTableData"
      height="100%"
      ref="trendTable"
      @select="tableSelectChange"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="60" align="center"></el-table-column>
      <el-table-column label="测点编码" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-popover
            popper-class="color-panel-popover"
            placement="top"
            width="266"
            v-model="scope.row.visible"
            @show="showColorBar(scope.row)"
          >
            <el-row :gutter="10">
              <el-col :span="12">
                <el-select
                  v-model="computedLineWidth"
                  style="width:100%;"
                  popper-class="visualization-select-popper"
                >
                  <el-option
                    v-for="item in widthOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select
                  v-model="computedLineStyle"
                  style="width:100%;"
                  popper-class="visualization-select-popper"
                >
                  <el-option
                    v-for="item in lineStyleOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <ul class="color_box">
              <li
                v-for="(item, index) in Array(16)"
                :key="`${index}color`"
                :class="{ active: colorIndex === index }"
                @click="setColorIndex(index)"
              >
                <div class="h-full w-full" :style="{ 'background-color': colorBar[index] }"></div>
              </li>
            </ul>
            <div style=" margin: 0;text-align: right">
              <el-button size="mini" type="text" @click="scope.row.visible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="setStyle(scope.row)">确定</el-button>
            </div>
            <div slot="reference" class="position-relative flex items-center">
              <div
                style="top:6px;left:0;width:12px;height:12px;"
                :style="{ 'background-color': scope.row.color }"
                class="position-absolute"
              ></div>
              <span class="ml-15px">{{ scope.row.code }}</span>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="中文名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="当前值" prop="currentValue" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            {{
              scope.row.currentValue
                ? (scope.row.currentValue * 1).toFixed(4)
                : scope.row.currentValue === 0
                ? 0
                : ''
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最大值" prop="maxValue" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            {{
              scope.row.maxValue
                ? (scope.row.maxValue * 1).toFixed(4)
                : scope.row.maxValue === 0
                ? 0
                : ''
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最小值" prop="minValue" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            {{
              scope.row.minValue
                ? (scope.row.minValue * 1).toFixed(4)
                : scope.row.minValue === 0
                ? 0
                : ''
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="平均值" prop="avg" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            {{ scope.row.avg ? (scope.row.avg * 1).toFixed(4) : scope.row.avg === 0 ? 0 : '' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Y轴自定义" width="240">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.minSection"
            @change="saveYAxis(scope.row)"
            style="width:100px;"
            size="mini"
            type="number"
          >
          </el-input
          >~
          <el-input
            v-model="scope.row.maxSection"
            style="width:100px;"
            size="mini"
            @change="saveYAxis(scope.row)"
            type="number"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button
            size="small"
            type="danger"
            @click="deletePoint(scope.row)"
          >
          删除
          </el-button> -->
          <div class="text-red-500 cursor-pointer" @click="deletePoint(scope.row)">删除</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/babel">
export default {
  props: {
    /* 已勾选的行数据 */
    selected: {
      type: Array,
      default: () => {
        return []
      },
    },
    /* 表格里的测点数据 */
    trendTableData: {
      type: Array,
      default: () => {
        return []
      },
    },
    colorIndex: Number,
    lineWidth: String,
    lineStyle: String,
    colorBar: Array,
    lineStyleOptions: Array,
    widthOptions: Array,
  },
  data() {
    return {
      computedLineStyle: this.lineStyle,
      computedLineWidth: this.lineWidth,
    }
  },
  methods: {
    // 显示颜色板
    showColorBar(row) {
      this.$emit('on-showColorBar', row)
    },
    // 确定测点设置
    setStyle(row) {
      this.$emit('on-showColorBar', {
        lineStyle: this.computedLineStyle,
        lineWidth: this.computedLineWidth,
      })
      this.$emit('on-setStyle', row)
    },
    // 删除测点
    deletePoint(row) {
      this.$emit('on-delete', row)
    },
    /* 勾选、去除勾选表格测点 */
    tableSelectChange(selected) {
      this.$emit('on-select', selected)
    },
    saveYAxis(row) {
      this.$emit('on-saveYAxis', row)
    },
    setColorIndex(index) {
      this.$emit('on-setColorIndex', index)
    },
    selectionChange(res) {},
  },
}
</script>
<style scoped lang="scss">
.trend_table {
  ::v-deep .el-table th .el-checkbox {
    display: none;
  }
}

.color_box {
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  flex-wrap: wrap;

  li {
    width: 20px;
    height: 20px;
    border: 5px solid transparent;
    box-sizing: content-box;

    &:hover {
      border-color: #1890ff;
    }

    &.active {
      border-color: #1890ff;
    }
  }
}
</style>

<style lang="scss">
.color-panel-popover {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
